import { Button, Col } from 'antd';

import EdenredButton from '../button/index';
import React from 'react';

const StepButton = ({ disabled, handleFinish, loading = false, handlePrev, handleNext, stepIndex, buttonText, buttonMode, secondaryHandleNext, linkUrl, ...rest }) => (
	<div className="steps-buttons-container">
		<div>
			<Col>
				<EdenredButton loading={loading} disabled={disabled} type={disabled ? 'outline_grey' : 'primary'} onClick={handleNext} formType="submit" {...rest}>
					{buttonText}
				</EdenredButton>
			</Col>
			{buttonMode === 'triple' ? (
				<div style={{ marginTop: '20px' }}>
					<div className="addbtn" style={{ textAlign: 'center' }}>
						{!linkUrl ? <button disabled={true} style={{ fontWeight: 400, cursor: 'not-allowed' }}>Save & Sign Later</button>
							: <a href={linkUrl} download="doc" onClick={secondaryHandleNext} style={{ width: '100%', padding: '2% 3%' }}>
								Save & Sign Later
							</a>}
					</div>
				</div>
			) : null}
		</div>
	</div>
);

export default StepButton;
